export default {
  cn: {
    seek: {
      dropdown: {
        funds: '出入金记录',
        acRecord: "代理佣金记录",
        wallet: "钱包",
        loginId: '登录账号',
        userName: '账户名称',
        IBcode: 'IB代码',
        phone: '电话',
        email: '电子邮箱',
        certificateId: '证件号码',
        superiorMT: '上级MT4账号',
        superiorMTIB: '上级IB代码',
      },
      err: {
        dateFormat: "YYYY-MM-DD",
        startDate: "请正确输入开始时间",
        endDate: "请正确输入结束时间",
      },
      show: '显示',
      password: '更改密码',
      indenta: '未平仓订单',
      indexb: '已平仓订单',
      submit: '提交',
      login: '登录',
      seek: '搜索',
      affirm: '确认'
    },
  },
  hk: {
    seek: {
      dropdown: {
        funds: '出入金記錄',
        acRecord: "代理佣金記錄",
        wallet: "錢包",
        loginId: '登錄帳號',
        userName: '帳戶名稱',
        IBcode: 'IB代碼',
        phone: '電話',
        email: '電子郵箱',
        certificateId: '證件號碼',
        superiorMT: '上級MT4帳號',
        superiorMTIB: '上級IB代碼',
      },
      err: {
        dateFormat: "YYYY-MM-DD",
        startDate: "請正確輸入開始時間",
        endDate: "請正確輸入結束時間",
      },
      show: '顯示',
      password: '更改密碼',
      indenta: '未平倉訂單',
      indexb: '已平倉訂單',
      submit: '提交',
      login: '登錄',
      seek: '搜索',
      affirm: '確認'
    }
  },
  en: {
    seek: {
      dropdown: {
        funds: 'Entry and exit record',
        acRecord: "Agent commission record",
        wallet: "wallet",
        loginId: 'loginId',
        userName: 'userName',
        IBcode: 'IBcode',
        phone: 'phone',
        email: 'email',
        certificateId: 'certificateId',
        superiorMT: 'superiorMT',
        superiorMTIB: 'superiorMTIB',
      },
      err: {
        dateFormat: "YYYY-MM-DD",
        startDate: "Please enter the start time correctly",
        endDate: "Please enter the start time correctly",
      },
      show: 'show',
      password: 'password',
      indenta: 'indenta',
      indexb: 'indexb',
      submit: 'submit',
      login: 'login',
      seek: 'search',
      affirm: 'affirm'
    }
  }
}



// WEBPACK FOOTER //
// ./src/MultiLanguage/btn.js